export const ProgressColor = {
  PRIMARY_CONTRAST: 'primary_contrast',
  SECONDARY_CONTRAST: 'secondary_contrast',
  POSITIVE_CONTRAST: 'positive_contrast',
  NEGATIVE_CONTRAST: 'negative_contrast',
  ATTENTION: 'attention'
};
export const ProgressSize = {
  DEFAULT: '100%',
  SMALL: 48,
  MEDIUM: 64,
  BIG: 96
};
export const SizeToStyle = {
  [ProgressSize.DEFAULT]: 'body',
  [ProgressSize.SMALL]: 'small',
  [ProgressSize.BIG]: 'h4',
  [ProgressSize.MEDIUM]: 'body'
};
export const DynamicValues = {
  SMALL: 0.25,
  TINY: 0.125
};